import { styled as t } from "styled-components";
import { BaseCommentContent as a } from "../components/BaseCommentContent/index.js";
import { CommentAvatar as r } from "../components/CommentAvatar/index.js";
import { CommentBadge as o } from "../components/CommentBadge/index.js";
import { defaultCardSpacing as e } from "../style.js";
const g = t.div`
  display: grid;
  column-gap: 4px;
  row-gap: 8px;
  grid-template-areas:
    '. badge'
    'avatar content';
  grid-template-columns: auto 1fr;
  height: auto;
  width: 100%;

  ${e}
`, c = t(r)`
  grid-area: avatar;
`, s = t(a)`
  grid-area: content;
`, f = t(o)`
  grid-area: badge;
`;
export {
  c as TipAvatar,
  f as TipBadge,
  g as TipContainer,
  s as TipContent
};
